import React from "react";
import PlanPolicyForm from "./PlanPolicyForm";
import { emptyPlanPolicy } from "./utils/providersSchema";
import { ReactComponent as BackIcon } from "../../../assets/icons/Back.svg";
import SecondaryButton from "../../DesignSystem/Buttons/SecondaryButton";
import PrimaryButton from "../../DesignSystem/Buttons/PrimaryButton";
import ProviderInput from "./components/ProviderInput";
import DragDropUpload from "./components/DragDropUpload";

const ProviderForm = ({
  mode = "add",
  provider,
  setProvider,
  providerLogoFile,
  setProviderLogoFile,
  plans,
  setPlans,
  onSave,
  saving,
}) => {
  const isEditMode = mode === "edit";
  const updatePlan = (index, updatedPlan) => {
    setPlans((prev) =>
      prev.map((plan, i) => (i === index ? updatedPlan : plan)),
    );
  };

  const addPlan = () => {
    setPlans((prev) => [
      ...prev,
      {
        ...emptyPlanPolicy,
        id: crypto.randomUUID(),
      },
    ]);
  };

  const removePlan = (index) => {
    setPlans((prev) => prev.filter((_, i) => i !== index));
  };

  const isSaveDisabled =
    saving ||
    !provider.providerName?.trim() ||
    !plans.some((plan) => plan.planName?.trim());

  return (
    <div className="provider-network-add-page">
      <div className="provider-network-breadcrumb">
        <BackIcon
          onClick={() => window.history.back()}
          style={{ cursor: "pointer" }}
        />

        <div className="FP_Help_Text">Provider Index</div>
        <span>&gt;</span>
        <div className="FP_Help_Text_Semibold">
          {isEditMode ? "Edit Provider" : "Add Provider"}
        </div>
      </div>

      <section className="provider-network-form-card">
        <div className="FP_Subtitle">Provider Details</div>

        <ProviderInput
          label="Provider Name"
          required
          value={provider.providerName}
          placeholder="Name of Provider Company"
          onChange={(value) =>
            setProvider((prev) => ({
              ...prev,
              providerName: value,
            }))
          }
        />
        <DragDropUpload
          label="Provider Logo"
          file={providerLogoFile}
          existingFile={
            provider.providerLogoUrl
              ? {
                  name: provider.providerName,
                  url: provider.providerLogoUrl,
                  path: provider.providerLogoPath,
                  type: "image",
                }
              : null
          }
          onExistingChange={(existingLogo) => {
            if (!existingLogo) {
              setProvider((prev) => ({
                ...prev,
                providerLogoUrl: "",
                providerLogoPath: "",
              }));
            }
          }}
          onChange={setProviderLogoFile}
          accept=".png,.jpg,.jpeg,.svg"
          acceptedText="Accepted file types: png, jpg, jpeg, svg"
        />
      </section>

      {plans.map((plan, index) => (
        <PlanPolicyForm
          key={plan.id || index}
          plan={plan}
          index={index}
          onChange={updatePlan}
          onRemove={removePlan}
          canRemove={plans.length > 1}
        />
      ))}

      <div className="provider-network-form-footer">
        <SecondaryButton
          type="button"
          className="provider-network-secondary-btn"
          onClick={addPlan}
          label="Add Plan/Policy"
        />

        <PrimaryButton
          type="button"
          className="provider-network-primary-btn"
          onClick={onSave}
          disabled={
            saving ||
            !provider.providerName?.trim() ||
            !plans.some((plan) => plan.planName?.trim())
          }
        >
          {saving
            ? "Saving..."
            : isEditMode
              ? "Update Provider"
              : "Save Changes"}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default ProviderForm;
